// Datos mock para membresías - Organizados para fácil migración a base de datos
export const membresiasData = {
  // Configuración de ciclos de facturación - Solo Anual disponible
  billingCycles: [
    { 
      id: 'anual', 
      label: 'Anual', 
      discount: 0,
      discountText: 'Precio único'
    }
  ],

  // Membresías disponibles - Solo Gold disponible actualmente
  membresias: [
    {
      id: 'gold',
      nombre: 'GOLD',
      descripcion: 'Membresía premium con beneficios exclusivos',
      popular: true,
      precios: {
        anual: {
          precioOriginal: 6999,
          precioFinal: 6999,
          descuento: 0
        }
      },
      // Características organizadas en 3 columnas según diseño oficial
      features: {
        columna1: [
        { 
          id: 'kit-bienvenida-gold',
          text: 'Kit de Bienvenida Gold', 
            included: true
        },
        { 
            id: 'comunidad-privada',
            text: 'Acceso a Comunidad privada Recomienda-T', 
            included: true
        },
        { 
            id: 'informacion-prioritaria',
            text: 'Información prioritaria de eventos y de oportunidades de negocio', 
            included: true
        },
        { 
            id: 'eventos-masterclass',
            text: 'Acceso a eventos y Master Class mensuales con precio especial Gold', 
            included: true
        },
        { 
            id: 'networking-prioritario',
            text: 'Networking prioritario, lugares VIP, oportunidad de presentar tu empresa en eventos', 
            included: true
        },
        { 
            id: 'visibilidad-premium',
            text: 'Visibilidad premium', 
            included: true
        },
        { 
            id: 'eventos-privados',
            text: 'Acceso exclusivo a eventos privados y dinámicas especiales para socios GOLD', 
            included: true
          }
        ],
        columna2: [
        { 
            id: 'crm-privado',
            text: 'Acceso a nuestro CRM privado generado por evento (Asistencia obligatoria)', 
            included: true
        },
        { 
            id: 'focus-group-mensual',
            text: 'Acceso al Focus group mensual con retroalimentación para tu negocio', 
            included: true
        },
        { 
            id: 'reporte-networking',
            text: 'Reporte de networking trimestral para medir tu crecimiento y contactos generados', 
            included: true
    },
    {
            id: 'relaciones-publicas',
            text: 'Relaciones públicas personalizadas', 
            included: true
          },
          { 
            id: 'presentacion-directa',
            text: 'Presentación directa con prospectos y aliados clave', 
            included: true
          },
        { 
            id: 'day-pass',
            text: '2 Day pass semanales (16 horas) en espacios físicos de trabajo (no acumulables)', 
            included: true
        },
        { 
            id: 'colaboracion-redes',
            text: 'Colaboración en redes sociales (publicaciones estratégicas para tu marca)', 
            included: true
          }
        ],
        columna3: [
        { 
            id: 'cuponera-servicios',
            text: 'Cuponera de servicios de socios y aliados', 
            included: true
        },
        { 
            id: 'comisiones-referencia',
            text: 'Comisiones por referencia de nuevos socios', 
            included: true
        },
        { 
            id: 'contrato-confidencialidad',
            text: 'Contrato de confidencialidad (En contrato de membresía)', 
            included: true
        },
        { 
            id: 'convenio-vinculacion',
            text: 'Convenio de vinculación', 
            included: true
        }
      ]
      }
    }
  ],

  // Configuración general
  config: {
    moneda: 'MXN',
    locale: 'es-MX',
    mostrarDescuentos: true,
    mostrarPreciosOriginales: true,
    textoDescuento: 'Únete a nuestra comunidad exclusiva y accede a beneficios premium.<br><span class="destacado">¡Ahorra hasta 20% con pagos anuales!</span>'
  }
};

// Funciones de utilidad para trabajar con los datos
export const formatPrice = (price, moneda = 'MXN', locale = 'es-MX') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: moneda,
    minimumFractionDigits: 0
  }).format(price);
};

export const getMembresiaById = (id) => {
  return membresiasData.membresias.find(membresia => membresia.id === id);
};

export const getBillingCycleById = (id) => {
  return membresiasData.billingCycles.find(cycle => cycle.id === id);
};

export const getPrecioMembresia = (membresiaId, billingCycleId) => {
  const membresia = getMembresiaById(membresiaId);
  if (!membresia) return null;
  
  return membresia.precios[billingCycleId] || null;
}; 